"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsPreviewMappers = exports.componentsMappers = void 0;
var componentExtensions_1 = require("./componentExtensions");
Object.defineProperty(exports, "componentsMappers", { enumerable: true, get: function () { return componentExtensions_1.componentsMappers; } });
var componentPreviewExtensions_1 = require("./componentPreviewExtensions");
Object.defineProperty(exports, "componentsPreviewMappers", { enumerable: true, get: function () { return componentPreviewExtensions_1.componentsPreviewMappers; } });
__exportStar(require("./components/schemas"), exports);
__exportStar(require("./types/components"), exports);
__exportStar(require("./types/core"), exports);
//# sourceMappingURL=index.js.map